import { render } from "./steps2.vue?vue&type=template&id=3de197e2"
import script from "./steps2.vue?vue&type=script&lang=js"
export * from "./steps2.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__